import React from 'react';
import { cn } from '../../lib/utils';

/**
 * Primary CTA — Spacemint fill, Spaceblack text (Spacebring brand).
 * Variants:
 *  - primary:  mint fill + dark text
 *  - secondary: white fill + hairline border + dark text
 *  - accent:   purple fill + white text (AI/tech emphasis)
 */
export default function AccentButton({
  children,
  className,
  type = 'button',
  disabled,
  onClick,
  as: Component = 'button',
  variant = 'primary',
  ...rest
}) {
  const variants = {
    primary:
      'bg-spacemint hover:bg-spacemint/85 text-spaceblack font-semibold rounded-full disabled:opacity-50 transition-all duration-200 hover:-translate-y-px',
    secondary:
      'bg-white hover:bg-paper text-ink font-medium border border-shell-border rounded-full disabled:opacity-50 transition-all duration-200 hover:-translate-y-px',
    accent:
      'bg-spacepurple hover:bg-spacepurple/90 text-white font-semibold rounded-full disabled:opacity-50 transition-all duration-200 hover:-translate-y-px',
  };

  return (
    <Component
      type={Component === 'button' ? type : undefined}
      disabled={disabled}
      onClick={onClick}
      className={cn(
        'inline-flex items-center justify-center gap-2 text-sm px-4 py-2',
        variants[variant] || variants.primary,
        className,
      )}
      {...rest}>
      {children}
    </Component>
  );
}
